import { Pipe, PipeTransform } from '@angular/core';

import { Product } from '../models/product';


@Pipe({
  name: 'priceFilter'
})

export class PriceFilter implements PipeTransform {

	transform(value: any, order?: any): any[] {

		if (value==null) return null;

		let keyArr: any[] = Object.keys(value),
		keyName = 'p',
		dataArr = [];

		keyArr.forEach((key: any) => {
			value[key][keyName] = key;
		    dataArr.push(value[key])
		});

		if(order == 'desc') {
			dataArr.sort((a: Object, b: Object): number => {
				return a[keyName] > b[keyName] ? -1 : 1;
			});
		} else {
			dataArr.sort((a: Object, b: Object): number => {
				return a[keyName] > b[keyName] ? 1 : -1;
			});
		}

		// return the resulting array
		return dataArr;

    }

}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/pipes/price.filter.pipe.ts